import { Select as AntSelect, SelectProps } from "antd";
import styled from "styled-components";

export const Select: typeof AntSelect = styled(AntSelect)<SelectProps<any>>``;
